import { App, Form, Button, Input, Flex } from 'antd'
import { useRequest } from 'ahooks'
import { formSubmit } from '@/api'
import Styles from './style.module.scss'

// 邮箱正则校验规则
const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export default function ContactForm() {
  const { message } = App.useApp()
  const [form] = Form.useForm()
  const { run, loading } = useRequest(formSubmit, {
    manual: true,
    onSuccess: res => {
      if (res?.code === 0) {
        message.success('Submitted successfully')
        form.resetFields()
      }
    },
  })

  return (
    <Form
      layout='vertical'
      variant='filled'
      size='large'
      form={form}
      className={Styles.formWrapper}
      onFinish={d => run({ ...d, subject_id: 1 })}
    >
      <Flex className={Styles.cell}>
        <Form.Item name='name' label='Full Name' rules={[{ required: true, message: 'Please enter your name!' }]}>
          <Input allowClear maxLength={100} placeholder='Please enter your name' />
        </Form.Item>
        <Form.Item
          label='Email'
          name='email'
          rules={[
            { required: true, message: 'Please enter your email address!' },
            {
              pattern: EMAIL_REGEX,
              message: 'email format is incorrect!',
            },
          ]}
        >
          <Input placeholder='Please enter email' />
        </Form.Item>
      </Flex>
      <Form.Item
        name='requirement'
        label='Requirement'
        rules={[{ required: true, message: 'Please enter requirement!' }]}
      >
        <Input.TextArea rows={3} allowClear placeholder='Please provide a detailed description of your requirements' />
      </Form.Item>
      <Button loading={loading} type='primary' htmlType='submit' className={Styles.subButton}>
        Send Message
      </Button>
    </Form>
  )
}
